import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "@core/services/auth";
import { map } from "rxjs/operators";


export const rootRedirectGuard: CanActivateFn = () => {
    const auth = inject(AuthService);
    const router = inject(Router);
    return auth.checkAuthStatus().pipe(
        map(isAuthenticated => router.createUrlTree(isAuthenticated ? ['/dashboard'] : ['/login']))
    );
}